import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';

import ProjectGalleryGrid from '../../branch-project-listing/project-gallery-grid';
import ProjectGalleryFilters from '../project-gallery-filters';

const ProjectGalleryWithFilters = ({ data, projects, productType, className }) => {
	const [filteredProjects, setFilteredProjects] = useState(projects);
	const [projectsToShow, setProjectsToShow] = useState(15);

	if (!isValidArray(projects)) return null;

	const onLoadMoreClick = () => setProjectsToShow(projectsToShow + 6);

	return (
		<div
			className={`py-8 xl:py-[42px] ${className || ''}`}
			data-testid='project-gallery-with-filter'
		>
			<Container className='relative'>
				{data?.heading && <h2 className='m-0'>{data?.heading}</h2>}

				<ProjectGalleryFilters
					productType={productType}
					projects={projects}
					setProjects={setFilteredProjects}
					className='my-4 md:my-5 xl:my-6'
				/>

				<ProjectGalleryGrid
					key={projectsToShow}
					projects={filteredProjects}
					projectsToShow={projectsToShow}
					onLoadMoreClick={onLoadMoreClick}
				/>
			</Container>
		</div>
	);
};

ProjectGalleryWithFilters.propTypes = {
	projects: PropTypes.array,
	className: PropTypes.string,
	data: PropTypes.object,
	productType: PropTypes.string,
};

export default ProjectGalleryWithFilters;
